import { useState } from "react";
import InfoDropdown from "../components/InfoDropdown";
import Splash from "../components/Splash";
import liftTruckImg from "../images/extra-pic.jpg"
import bgImg from "../images/service-banner.jpg"
import liftLogo from "../images/logo-lift-white.png"

function RepairsAndServicePage() {

    const [activeDropdown, setActiveDropdown] = useState(null);

    const text = (
        <div>
            <img src={liftLogo} className="w-1/3 md:w-2/3"/>
            <h1 className="text-4xl md:text-6xl uppercase text-white font-bold pb-2 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)] md:drop-shadow-none">Repairs<br/>And<br/>Service</h1>
            <p className="text-2xl md:text-3xl text-white drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)] md:drop-shadow-none">We've got you covered.</p>
        </div>
    );

    const descriptions = {
        one: "Our fleet of mobile repair vans covers all of Atlantic Canada. We know where our technicians are, so we can get to you and your material handling equipment faster.",
        two: "We are committed to perform the highest level of service and repair on your forklift or other material handling equipment. We are so confident in our ability we’ve created a Performance Guarantee for our customers.",
        three: "For fleet users we can lower your operating costs, track your service costs, and provide monthly or quarterly reporting, including per-hour cost per truck. In addition, never have a forklift or other lift truck down with our loaner program with guaranteed response time and no-hassle maintenance program."
    };

    const titles = {
        one: "GPS Dispatched Service",
        two: "Performance Guarantee",
        three: "Fleet Maintenance Program"
    };

    const handleClick = (key) => {
        setActiveDropdown(activeDropdown === key ? null : key);
    }

    return (
        <div>
            <div>
                <Splash image={bgImg} text={text} />
            </div>
            <div className="mx-auto my-10 flex flex-col md:flex-row columns-2 gap-5 items-start justify-center w-4/5 md:w-1/2">
                <img src={liftTruckImg} className="w-full md:w-1/2" />
                <div className="w-full md:w-1/2">
                    <div className="flex flex-col gap-5">
                        {Object.keys(titles).map(key => (
                            <InfoDropdown
                                key={key}
                                title={titles[key]}
                                description={descriptions[key]}
                                isOpen={activeDropdown === key}
                                onClick={() => handleClick(key)}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RepairsAndServicePage;